import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	quickFilter: null,
	selectedContactIds: [],
	contacts: [],
	sort: 'orderingClientName,asc',
	resetRelatedSections: true,
};

const reducerMap = {
	[types.SET_SORT]: (state, { payload }) => {
		return {
			...state,
			sort: payload.sort,
		};
	},
	[types.SET_RESET_RELATED_SECTIONS]: (state, { payload }) => {
		return {
			...state,
			resetRelatedSections: payload.resetRelatedSections,
		};
	},
	[types.SET_CONTACTS]: (state, { payload }) => {
		return {
			...state,
			selectedContactIds: [],
			contacts: payload.contacts,
		};
	},
	[types.APPEND_CONTACTS]: (state, { payload }) => {
		return {
			...state,
			contacts: state.contacts.concat(payload.contacts),
		};
	},
	[types.TOGGLE_CONTACT]: (state, { payload }) => {
		if (state.selectedContactIds.includes(payload.id)) {
			return {
				...state,
				selectedContactIds: state.selectedContactIds.filter((id) => id !== payload.id),
			};
		} else {
			return {
				...state,
				selectedContactIds: state.selectedContactIds.concat(payload.id),
			};
		}
	},
	[types.SET_QUICK_FILTER]: (state, { payload }) => {
		return {
			...state,
			quickFilter: payload.quickFilter,
		};
	},
	[types.RESET_SELECTED_CONTACTS]: (state) => {
		return {
			...state,
			selectedContactIds: [],
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
